// extracted by mini-css-extract-plugin
module.exports = {"viewerDimention":"styles_viewerDimention__2jG3k"};